
import React from "react";
import { 
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    IconButton,
    Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './WarningDialog.styles'

const WarningDialog = (props: any): JSX.Element => {
  const { showPrompt, onNo, onYes, title, contentText, boldText } = props;
  const { classes } = useStyles();

  const handleCancel = (event: any, reason: string) =>{
    if (reason && reason === "backdropClick") 
        return;
    onNo();
  }

  const handleOK = () => {
    onYes();
  };

  interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }

  const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2, fontWeight:400 }} {...other} className={classes.dialogTitle}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
             position: 'absolute',
             right: 8,
             top: 8,
             color: '#18477D',
             fontSize: 20,
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  return (
    <div>
        <Dialog
        open={showPrompt}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{paper:classes.dialog}}
        disableEscapeKeyDown={true}
        >
        <BootstrapDialogTitle onClose={()=>handleCancel(null, '')} id={''}>
          {title}
        </BootstrapDialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogContentText}>
            {contentText}
            {boldText ?(<Typography className={classes.boldText}><b>{boldText}</b></Typography>): ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={boldText? classes.dialogActionsWithBoldText:classes.dialogActions}>
          <Button variant="outlined" className={classes.dialogButtonNo} onClick={()=>handleCancel(null, '')} sx={{textTransform:'none'}}>No</Button>
          <Button variant="outlined" onClick={handleOK} autoFocus className={classes.dialogButtonYes} sx={{textTransform:'none'}}>
              Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WarningDialog;
